<template>
  <div class="op-card" :style="'--accent:' + item.backgroundColor">

    <div class="op-card__header">
      <span class="op-card__dot"></span>
      <span class="op-card__type">
        <template v-if="item.type == 'delivery'">Saída</template>
        <template v-else>Retorno</template>
      </span>
      <span class="op-card__number">Nº{{ item.numberRent }}</span>
    </div>

    <div class="op-card__date">
      <template v-if="item.type == 'delivery'">{{ item.startStr }}</template>
      <template v-else>{{ item.endStr }}</template>
    </div>

    <div class="op-card__identification">
      <span v-if="item.identification">{{ item.identification }}</span>
      <span class="op-card__no-id" v-else>Sem identificação</span>
    </div>

    <div class="op-card__info">
      <div class="op-card__info-row">
        <i class="fa-solid fa-building op-card__info-icon"></i>
        <span class="op-card__info-text" :title="item.companyName">{{ item.companyName }}</span>
      </div>
      <div class="op-card__info-row">
        <i class="fa-solid fa-user op-card__info-icon"></i>
        <span class="op-card__info-text" :title="item.contactName">{{ item.contactName }}</span>
      </div>
    </div>

    <div class="op-card__actions">
      <ButtonMovimentStock :totalization="item.totalization" :showTitleButton="false"
                           :keyButton="item.keyButton" :rentId="item.rentId"
                           :periodRentId="item.periodRentId"/>
      <Button :_key="item.keyButton + 'eye'" tooltip="Visualizar" type="primary"
              classIcon="fa-solid fa-eye" size="small" :clicked="() => $emit('view', item)"/>
      <Button :_key="item.keyButton + 'edit'" tooltip="Editar" color="white"
              backGroundColor="#A9A9A9" classIcon="fa-solid fa-pen-to-square" size="small"
              :clicked="() => $emit('edit', item)"/>
      <Button :_key="item.keyButton + 'share'" tooltip="Compartilhar" type="info"
              classIcon="fa-sharp fa-regular fa-share-nodes" size="small"
              :clicked="() => $emit('share', item)"/>
    </div>
  </div>
</template>

<script>
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import ButtonMovimentStock from "../ButtonMovimentStock.vue";

export default {
  name: "OsPanelCardItem",
  components: {Button, ButtonMovimentStock},
  props: {
    item: {type: Object, required: true},
  },
};
</script>

<style scoped>
.op-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #ffffff;
  border: 1px solid #e4e8f0;
  border-top: 3px solid var(--accent, #009183);
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  transition: box-shadow 0.18s, transform 0.15s;
}

.op-card:hover {
  box-shadow: 0 6px 22px rgba(0, 0, 0, 0.09);
  transform: translateY(-2px);
}

.op-card__header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 11px 14px 9px;
  border-bottom: 1px solid #f0f3f8;
}

.op-card__dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: var(--accent, #009183);
  flex-shrink: 0;
}

.op-card__type {
  font-size: 12px;
  font-weight: 700;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  flex: 1;
}

.op-card__number {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  background: #f3f4f6;
  border-radius: 999px;
  padding: 2px 9px;
  white-space: nowrap;
}

.op-card__date {
  font-size: 21px;
  font-weight: 700;
  color: #1f2937;
  text-align: center;
  padding: 12px 14px 6px;
  letter-spacing: -0.01em;
}

.op-card__identification {
  text-align: center;
  padding: 0 14px 10px;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  min-height: 26px;
}

.op-card__no-id {
  font-size: 12px;
  color: #9ca3af;
  font-style: italic;
}

.op-card__info {
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 0 14px 14px;
  flex: 1;
}

.op-card__info-row {
  display: flex;
  align-items: center;
  gap: 7px;
  overflow: hidden;
}

.op-card__info-icon {
  font-size: 12px;
  color: #9ca3af;
  width: 13px;
  flex-shrink: 0;
  text-align: center;
}

.op-card__info-text {
  font-size: 13px;
  color: #4b5563;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.op-card__actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1px;
  padding: 8px 6px;
  border-top: 1px solid #f0f3f8;
  background: #fafbfd;
  flex-wrap: wrap;
}
</style>
